<div class="editor-page">
  <div class="container page">
    <div class="row">
      <div class="col-md-10 offset-md-1 col-cs-12">
        <mc-backend-error-messages
          *ngIf="errorsProps"
          [backendErrors]="errorsProps"
        ></mc-backend-error-messages>
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <fieldset>
            <fieldset class="form-group">
              <input
                type="text"
                class="form-control form-control-lg"
                placeholder="Article title"
                formControlName="title"
              />
            </fieldset>
            <fieldset class="form-group">
              <input
                type="text"
                class="form-control form-control-lg"
                placeholder="What is this article about?"
                formControlName="description"
              />
            </fieldset>
            <fieldset class="form-group">
              <textarea
                class="form-control form-control-lg"
                rows="8"
                placeholder="Write your article (in markdown)"
                formControlName="body"
              ></textarea>
            </fieldset>
            <fieldset class="form-group">
              <input
                type="text"
                class="form-control form-control-lg"
                placeholder="Enter tags"
                formControlName="tagList"
              />
            </fieldset>
            <fieldset>
              <button
                type="submit"
                class="btn btn-lg pull-xs-right btn-primary"
                [disabled]="form.invalid || isSubmittingProps"
              >
                Publish article
              </button>
            </fieldset>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
</div>
